import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import './Services.css';

const Privacy = () => {
  const { t } = useTranslation();

  return (
    <div className="services-page legal-page">
      <section className="page-hero modern-page-hero">
        <div className="page-hero-pattern"></div>
        <div className="page-hero-overlay"></div>
        <Container>
          <div className="page-hero-content">
            <h1 className="animate-appear">{t('legal.privacy.title', 'Política de Privacidad')}</h1>
            <p className="animate-appear">
              {t('legal.privacy.subtitle', 'Cómo recopilamos, usamos y protegemos su información en ProMedic Group.')}
            </p>
          </div>
        </Container>
      </section>

      <section className="section modern-section">
        <Container>
          <Row className="justify-content-center">
            <Col lg={9}>
              <p className="text-muted mb-4">{t('legal.lastUpdated', 'Última actualización: 2026')}</p>

              <h2 className="h4 mb-3">{t('legal.privacy.section1.title', '1. Información que recopilamos')}</h2>
              <p>{t('legal.privacy.section1.text', 'Recopilamos la información que usted nos proporciona directamente a través de nuestro formulario de contacto (nombre, correo electrónico, teléfono y mensaje), con el único fin de responder a su solicitud.')}</p>

              <h2 className="h4 mb-3 mt-4">{t('legal.privacy.section2.title', '2. Uso de la información')}</h2>
              <p>{t('legal.privacy.section2.text', 'Utilizamos su información únicamente para dar seguimiento a consultas comerciales, elaborar cotizaciones y comunicarnos con usted sobre nuestros servicios. No vendemos ni compartimos su información con terceros para fines de mercadeo.')}</p>

              <h2 className="h4 mb-3 mt-4">{t('legal.privacy.section3.title', '3. Protección de datos')}</h2>
              <p>{t('legal.privacy.section3.text', 'Aplicamos medidas técnicas y organizativas razonables para proteger la información que nos confía contra accesos no autorizados, pérdida o alteración.')}</p>

              <h2 className="h4 mb-3 mt-4">{t('legal.privacy.section4.title', '4. Sus derechos')}</h2>
              <p>{t('legal.privacy.section4.text', 'Usted puede solicitar en cualquier momento la actualización o eliminación de su información de contacto escribiéndonos directamente.')}</p>

              <h2 className="h4 mb-3 mt-4">{t('legal.privacy.section5.title', '5. Contacto')}</h2>
              <p>{t('legal.privacy.section5.text', 'Para consultas sobre esta política, puede escribirnos a')} <a href="mailto:jorge.murillo@promedicgroup.com">jorge.murillo@promedicgroup.com</a>.</p>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Privacy;
